import { Card, Col, Divider, Flex, Form, Row, Select, TimePicker, Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import {
  useGetDateRulesQuery,
  useUpdateDateRulesMutation,
} from './appConfig/endpoint/appConfigEndpoint';
import {
  FormInputSwitch,
  FormSelectInput,
  NumberInput,
} from 'components/common/FormItem/FormItems';
import SubmitButton from 'common/SubmitButton';
import { useAppSelector } from 'app/hooks';
import { selectUser } from 'auth/states/userSlice';

type Props = {};

const { Text } = Typography;

const SalesDateConfig = (props: Props) => {
  const [form] = Form.useForm();

  const { data, isLoading } = useGetDateRulesQuery();
  const [updateDateRules, { isLoading: isUpdating }] = useUpdateDateRulesMutation();

  const result = data?.data;

  useEffect(() => {
    if (result) {
      form.setFieldsValue({
        pastDates: result.pastDates === 1,
        futureDates: result.futureDates === 1,
        enabled: result.enabled == 1 ? '1' : '0',
        maxDaysBeforeToday: result.maxDaysBeforeToday,
        cutoffTime: result.cutoffTime ? dayjs(result.cutoffTime, 'HH:mm:ss') : null,
      });
    }
  }, [result]);

  const onFinish = (values: any) => {
    const formattedData = {
      pastDates: values.pastDates ? 1 : 0,
      futureDates: values.futureDates ? 1 : 0,
      enabled: values.enabled,
      maxDaysBeforeToday: values.maxDaysBeforeToday,
      cutoffTime: values.cutoffTime ? values.cutoffTime.format('HH:mm:ss') : null,
    };

    updateDateRules(formattedData);
    // console.log('Final JSON Output:', formattedData);
  };

  const user = useAppSelector(selectUser);

  const isArman = user?.user_id === 1661;
  if (!isArman) {
    return <>No access</>;
  }

  return (
    <Card
      loading={isLoading}
      size='small'
      style={{ width: 1000, margin: '0px auto' }}
      title={<Text>Manage date availability, limits, and daily cutoff times.</Text>}
    >
      <Divider orientation='left' orientationMargin='0'>
        Availability & Permissions
      </Divider>

      <Form form={form} onFinish={onFinish} layout='vertical'>
        <Row gutter={16}>
          <FormInputSwitch name='pastDates' label='Allow Past Dates :' lg={8} />
          <FormInputSwitch name='futureDates' label='Allow Future Dates :' lg={8} />
        </Row>

        <Divider orientation='left' orientationMargin='0'>
          Constraints & Rules
        </Divider>

        <Row gutter={12}>
          {/* <FormSelectInput
            name='enabled'
            label='Apply Rules Selection :'
            initialValue={1}
            data={[
              { label: 'Enable', value: 1 },
              { label: 'Disable', value: 0 },
            ]}
          /> */}

          <Col lg={8}>
            <Form.Item name='enabled' label='Apply Rules Selection :' initialValue={'1'}>
              <Select
                options={[
                  { label: 'Enable', value: '1' },
                  { label: 'Disable', value: '0' },
                ]}
              />
            </Form.Item>
          </Col>

          <NumberInput
            name='maxDaysBeforeToday'
            placeholder='e.g. 1'
            label='Max days allowed before today :'
            size={8}
          />

          <Col xs={24} lg={8}>
            <Form.Item name='cutoffTime' label='Daily Cutoff Time :'>
              <TimePicker format='HH:mm:ss' style={{ width: '100%' }} placeholder='Select time' />
            </Form.Item>
          </Col>
        </Row>

        <Flex justify='end'>
          <SubmitButton name='Submit' htmlType='submit' loading={isUpdating} />
        </Flex>
      </Form>
    </Card>
  );
};

export default SalesDateConfig;
